import * as React from "react";
import classnames from "classnames";
import { Text } from "@grandvisionhq/elements";
/* empty css                            */
const ShowroomModelIndicator = ({ label, className }) => /* @__PURE__ */ React.createElement("div", { className: classnames("common-showroommodel-indicator", className) }, /* @__PURE__ */ React.createElement("span", { className: "common-showroommodel-indicator__dot" }), /* @__PURE__ */ React.createElement(Text, { variant: "caption-head" }, label));
export {
  ShowroomModelIndicator as default
};
//# sourceMappingURL=ShowroomModelIndicator.js.map
